import View from '@/components/common/view'
// 物流特三
import index from '../components/forklift/index';
import EmployerEdit from '../components/forklift/edit';
import EmployerFillin from '../components/forklift/fillin';
import EmployerConfirm from '../components/forklift/confirm';
import success from '../components/forklift/success.vue';
import editSuccess from '../components/forklift/editsuccess.vue';
export default [
	{
		path:'',
		component:View,
		children:[
			{
				path:'index',
				component:index
			},
			{
				path:'fillin/:id?',
				component:EmployerFillin
			},
			{
				path:'edit/:id',
				component:EmployerEdit
			},
			{
				path:'confirm/:id?',
				component:EmployerConfirm
			},
            {
				path:'success/:id?',
				component:success
			},
            {
				path:'editSuccess/:id?',
				component:editSuccess
			}
		]
	}
]


// WEBPACK FOOTER //
// ./src/pages/haierProduct/router/forklift.js